import React from "react";
import styled from "@emotion/styled";

import Tooltip from "components/ui/tooltip/Tooltip";
import { useCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { joinToEnglishList } from "lib/utils";

export function NoticeSeenBy({
  seenByUsers,
  className,
  displayNumber,
}: {
  seenByUsers: {
    guid: string;
    firstName: string;
  }[];
  className?: string;
  displayNumber?: boolean;
}): JSX.Element | null {
  const { data: currentUser } = useCurrentUser();

  if (!currentUser || seenByUsers.length === 0) {
    return null;
  }

  const userNames = seenByUsers.map((u) => {
    return u.guid === currentUser.guid ? "you" : `${u.firstName}`;
  });

  const tooltipTile = `Seen by ${joinToEnglishList(userNames)}`;

  return (
    <Tooltip content={tooltipTile}>
      <div className={className} aria-label="Notice has been seen">
        <UIcon icon="checkDouble" color={displayNumber ? "blue600" : undefined} size={14} />
        {displayNumber && <DisplayNumber>{seenByUsers.length}</DisplayNumber>}
      </div>
    </Tooltip>
  );
}

const DisplayNumber = styled.span({
  verticalAlign: "text-top",
  paddingLeft: "4px",
});
